module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('div', {
    staticClass: "my-4 display-1"
  }, [_vm._v("Podaci o korisniku")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Ime",
      "required": ""
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Adresa",
      "required": ""
    },
    model: {
      value: (_vm.user.address),
      callback: function($$v) {
        _vm.$set(_vm.user, "address", $$v)
      },
      expression: "user.address"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Telefon",
      "required": ""
    },
    model: {
      value: (_vm.user.phone),
      callback: function($$v) {
        _vm.$set(_vm.user, "phone", $$v)
      },
      expression: "user.phone"
    }
  }), _vm._v(" "), (_vm.user.isCourier) ? _c('v-switch', {
    attrs: {
      "label": "Na poslu"
    },
    model: {
      value: (_vm.online),
      callback: function($$v) {
        _vm.online = $$v
      },
      expression: "online"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "large": "",
      "block": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("sačuvaj")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "success"
    },
    model: {
      value: (_vm.success),
      callback: function($$v) {
        _vm.success = $$v
      },
      expression: "success"
    }
  }, [_vm._v("Podaci su sačuvani")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "error"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_vm._v("Došlo je do greške, pokušajte ponovo ili kontaktirajte podršku")])], 1)], 1)], 1)
},staticRenderFns: []}